import { setHeader } from '@/util/set-header';
import React from 'react';
import "./relet.less";
import { withRouter } from "react-router";
import { reletCancelApi, reletCommitApi, reletDetailApi, departListApi } from "@/api/sany";
import  moment  from "moment";
import { NoticeBar, Steps, DatePicker, TextareaItem, Button, Modal, Picker, Toast } from "antd-mobile";
import { getUrlQueryDic } from '@/util/util';
const Step = Steps.Step
// const nowTimeStamp = Date.now();
// const now = new Date(nowTimeStamp);

@(withRouter as any)
export default class Relet extends React.Component<any,any> {
  state = {
    notice: '退房申请提交后不可修改，请及认真填写退房信息哦~',
    reletWay: 'cycle', // 按周期：cycle 按日期：date
    cycle: '1',
    cycleLabel: '1个月',
    reletDate: '',
    payWayLabel: '',
    // payWay: '',
    // 选择支付的部门
    depart: '',
    reason: '',
    status: '', // 1：待审核 2：待生效 3：已取消 4：已驳回 5：已完成
    rejectReason: ''
  }
  detail: any = {primary_room: {}, apply_room: {}}
  cycles = [{label: '1个月', value: '1'},
            {label: '2个月', value: '2'},
            {label: '3个月', value: '3'},
            {label: '4个月', value: '4'},
            {label: '5个月', value: '5'},
            {label: '6个月', value: '6'},
            {label: '7个月', value: '7'},
            {label: '8个月', value: '8'},
            {label: '9个月', value: '9'},
            {label: '10个月', value: '10'},
            {label: '11个月', value: '11'},
            {label: '12个月', value: '12'}]

  payWays = [
    {label: '部门划转', value: '2', children: [{label: '大部门', value: '10'},{label: '中部门', value: '11'},{label: '小部门', value: '12'}]},
    {label: '工资划扣', value: '1'}
  ]

  constructor(prop: any) {
    super(prop)
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.reletComponent = this.reletComponent.bind(this)
    this.reletWayChange = this.reletWayChange.bind(this)
    this.cycleChange = this.cycleChange.bind(this)
    this.cycleComponent = this.cycleComponent.bind(this)
    this.dateComponent = this.dateComponent.bind(this)
    this.payWayComponent = this.payWayComponent.bind(this)
    this.submitClick = this.submitClick.bind(this)
    this.dateChange = this.dateChange.bind(this)
  }

  componentDidMount() {
    setHeader({title: '续租', leftToHome: this.goHomePage, leftClick: this.leftClick})
    this.fetchDetail()
    this.fetchDepartList()
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      window.location.href = "uhomeoc://thirdparty.goBack?params={type:native}"
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  rightComponent() {
    if (this.state.status === '1') {
      return (
        <img onClick={()=>this.callPhone()} src="/public/assets/img/call_icon.png" alt=""/>
      )
    }
  }

  callPhone() {
    window.location.href = ("tel:" + this.detail.apply_room.store_contact_way)
  }

  // 获取续租详情
  async fetchDetail() {
    let checkin_id = ''
    const dic = getUrlQueryDic(this.props.location.search)
    if (dic.id) {
      checkin_id = dic.id
    } else if (this.props.location.state.checkinId) {
      checkin_id = this.props.location.state.checkinId
    }
    Toast.loading('加载中...')
    const {data} = await reletDetailApi({checkin_id})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      this.detail = data.data
      if (data.data.apply_room.length !== 0) {
        this.setState({
          reletDate: this.detail.apply_room.continue_time,
          payWayLabel: this.detail.apply_room.pay_type ? this.detail.apply_room.pay_type : '',
          reason: this.detail.apply_room.remark,
          status: this.detail.apply_room.status ?? '',
          rejectReason: this.detail.apply_room.reject_reason
        })
      }
      this.configNotice()
      if (this.state.status === '1') {
        setHeader({title: '续租', leftToHome: this.goHomePage, leftClick: this.leftClick, right: this.rightComponent()})
      }
    }
  }

  // 提交续租
  async submitRelet() {
    if (this.state.reletDate === '') {
      Toast.info('请选择日期~')
      return
    }
    const params = {
      checkin_id: this.props.location.state.checkinId,
      checkin_customer_id: this.props.location.state.customerId,
      remark: this.state.reason,
      continue_time: moment(this.state.reletDate).format('yyyy-MM-DD')
    }
    Toast.loading('提交中...')
    const {data} = await reletCommitApi({data: params})
    Toast.hide()
    if (data.code === 'SUCCESS') {
      Toast.info('提交成功~')
      this.fetchDetail()
    } else {
      Toast.info(data.msg)
    }
  }

  // 取消续租
  async cancelRelet() {
    const params = {id: this.detail.apply_room.id}
    const {data} = await reletCancelApi({data: params})
    if (data.code === 'SUCCESS') {
      Toast.info(data.msg)
      this.fetchDetail()
    } else {
      Toast.info(data.msg)
    }
  }

  // 获取该员工所属部门
  async fetchDepartList() {
    const num = this.props.location.state.num
    const {data} = await departListApi({num})
    if (data.code === 'SUCCESS') {
      let children: any = []
      data.data.forEach((ele: any) => {
        children.push({label: ele.name, value: ele.id})
      });
      this.payWays[0].children = children
    }
  }

  configNotice() {
    // 1：待审核 2：待生效 3：已取消 4：已驳回 5：已完成
    let notice = '续租申请提交后不可修改，请及认真填写续租信息哦~'
    if (this.state.status === '1') {
      notice = '已成功提交续租申请~'
    } else if (this.state.status === '5') {
      notice = '为了保障入住正常，请及时联系宿管处理~'
    } else if (this.state.status === '4') {
      notice = '续租申请被驳回，需要续租请重新申请~'
    } else if (this.state.status === '3') {
      notice = '续租申请已取消，需要续租请重新申请~'
    }
    this.setState({
      notice
    })
  }

  // 滚动通知栏
  noticeBarComponent() {
    return <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>{this.state.notice}</NoticeBar>
  }

  // 驳回原因
  rejectReasonComponent() {
    return (
      <div className="component-body">
        <div className="lease-status">
          <span style={{fontSize: '14px', color: '#515151', width: '100px'}}>驳回原因：</span>
          <span style={{color: '#868686', fontSize: '12px', overflowWrap: 'break-word', width: '250px', textAlign: 'right'}}>{this.state.rejectReason}</span>
        </div>
      </div>
    )
  }

  // 步骤条
  stepComponent() {
    // 1：待审核 2：待生效 3：已取消 4：已驳回 5：已完成
    const status2 = this.state.status !== '' ? 'finish' : 'wait'
    const status = this.state.status !== '' ? ((this.state.status !== '1' && this.state.status !== '2') ? 'finish' : 'wait') : 'wait'
    const title = this.state.status !== '' ? (this.state.status !== '1' && this.state.status !== '2' ? this.detail.apply_room.status_info : '完成') : '完成'
    const step2Icon = this.state.status !== '' ? '/public/assets/img/step_loading_select.png' : '/public/assets/img/step_loading.png'
    let step3Icon = '/public/assets/img/step_room.png'
    if (this.state.status === '5') {
      step3Icon = '/public/assets/img/step_room_select.png'
    } else if (this.state.status === '1') {
      step3Icon = '/public/assets/img/step_room.png'
    } else if (this.state.status === '3' || this.state.status === '4') {
      step3Icon = '/public/assets/img/step_end.png'
    } else {
      step3Icon = '/public/assets/img/step_room.png'
    }
    const applyTime = this.detail.apply_room.add_time ? moment(this.detail.apply_room.add_time).format('yyyy-MM-DD') : ''
    const endTime = this.detail.apply_room.update_time ? moment(this.detail.apply_room.update_time).format('yyyy-MM-DD') : ''
    return (
      <div className="step-body">
        <Steps direction="horizontal" size="small">
          <Step status="finish" title={this.customTitle('续租申请', 'finish')} description={this.customDesc(applyTime, 'finish')} icon={this.customIcon('/public/assets/img/step_start_select.png')} />
          <Step status="wait" title={this.customTitle('宿管处理中', status2)} description={this.customDesc('', status2)} icon={this.customIcon(step2Icon)} />
          <Step status="wait" title={this.customTitle(title, status)} description={this.customDesc(endTime, status)} icon={this.customIcon(step3Icon)} />
        </Steps>
      </div>
    )
  }

  customTitle(title: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <div style={{fontSize:'12px', color: color}}>{title}</div>
    )
  }

  customDesc(desc: string, status: string) {
    const color = status === 'finish' ? '#dd6572' : '#aeaeae'
    return (
      <span style={{color: color, fontSize: '12px'}}>{desc}</span>
    )
  }

  customIcon(img: string) {
    return (
      <img src={img} alt="" style={{width: '25px', height: '25px'}}/>
    )
  }

  // 去签约
  goSignComponent() {
    return (
      <div className="component-body">
        <div className="go-sign">
          <Button className="go-sign-btn" onClick={() => this.goSignClick()}>去签约</Button>
          <span style={{fontSize: '12px', color: '#515151'}}>续租成功！签约后即可正常入住，马上签约吧~</span>
        </div>
      </div>
    )
  }

  goSignClick() {
    this.props.history.push({pathname: '/sany/sign', state: {contractId: this.detail.contract_id}})
  }

  roomInfoComponent() {
    const startDay = moment(this.detail.primary_room.start_day).format('yyyy-MM-DD')
    const endDay = moment(this.detail.primary_room.end_day).format('yyyy-MM-DD')
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-title">
            <span style={{color: '#333333', fontSize: '14px'}}>房间信息</span>
          </div>
          <div className="dorm-info-top">
            <span style={{color: '#868686', fontSize: '16px'}}>{this.detail.primary_room.store_name}</span>
            <span style={{color: '#1b1b1b', fontSize: '14px'}}>{this.detail.primary_room.building_no}栋 {this.detail.primary_room.room_no} {this.detail.primary_room.bed_no}</span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>入住类型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.primary_room.property}</span>
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>预订房型：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.primary_room.room_type_name}</span>
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>租期：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{startDay}-{endDay}</span>
            </div>
            <div className="between-row" style={{height: '40px'}}>
              <span style={{color: '#434343', fontSize: '13px'}}>付费方式：</span>
              <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.primary_room.pay_type}</span>
            </div>
            {this.detail.primary_room.pay_type_id == '2' ?
                <div className="between-row" style={{height: '40px'}}>
                  <span style={{color: '#434343', fontSize: '13px'}}>扣费部门：</span>
                  <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.primary_room.primary_organization}</span>
                </div> : null}
          </div>
        </div>
      </div>
    )
  }

  // 续租信息
  reletComponent() {
    // const title = this.state.status === '' ? '请选择' : ''
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-title">
            <span style={{color: '#333333', fontSize: '14px'}}>续租信息</span>
          </div>
          <div className="dorm-info-mid">
            {this.dateComponent()}
            {this.payWayComponent()}
            {this.payDepartment()}
            {this.state.status === '' ? <span style={{color: '#c04f5b', fontSize: '12px'}}>为了保证预订申请有效，请与部门确定付费方式！</span> : null }
            <div className="dorm-info-bottom">
              <span style={{color: '#434343', fontSize: '13px', width: '60px'}}>原因：</span>
              {this.state.status === '' ? 
                <TextareaItem className="remark-input" maxLength={50} onChange={e => this.remarkChange(e)} placeholder="请输入原因(50字以内)" rows={3} /> : 
                <span style={{color: '#868686', fontSize: '12px', overflowWrap: 'break-word', width: '250px', textAlign: 'right'}}>{this.detail.apply_room.remark}</span>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  // 续租方式
  reletWayChange(type: string) {
    this.setState({
      reletWay: type
    })
  }

  // 选择周期row
  cycleComponent() {
    const title = this.state.status === 'apply' ? '请选择' : ''
    return (
      <div className="between-row" style={{height: '30px'}}>
        <span style={{color: '#434343', fontSize: '13px'}}>{this.state.status === 'apply' ? <span style={{color: 'red'}}>*</span> : null}{title}续租周期：</span>
        {this.state.status === 'apply' ?
          <Picker data={this.cycles} cols={1}  onOk={v => this.cycleChange(v)}>
            <div className="relet-cycle">{this.state.cycleLabel}</div>
          </Picker> :
          <span style={{color: '#868686', fontSize: '12px'}}>{this.state.cycle}</span>
        }
      </div>
    )
  }

  // 选择续租日期
  dateComponent() {
    const title = this.state.status === '' ? '请选择' : ''
    const reletDate = this.state.reletDate === '' ? '请选择日期' : this.state.reletDate
    const minDate = this.detail&&this.detail.primary_room&&this.detail.primary_room.end_day? this.getNextDay(this.detail.primary_room.end_day, 1) : undefined
    return (
      <div className="between-row" style={{height: '40px'}}>
        <span style={{color: '#434343', fontSize: '13px'}}>{this.state.status === '' ? <span style={{color: 'red'}}>*</span> : null}{title}结束日期：</span>
        {this.state.status === '' ? 
        // minDate={minDate}
          <DatePicker mode="date" title="选择时间" extra="Optional"  minDate={minDate} onChange={this.dateChange}>
            <div className="relet-cycle">{reletDate}</div>
          </DatePicker> :
          <span style={{color: '#868686', fontSize: '12px'}}>{moment(this.state.reletDate).format('yyyy-MM-DD')}</span>
        }
      </div>
    )
  }

  dateChange(v: any) {
    const reletDate = moment(v).format('yyyy-MM-DD')
    this.setState({
      reletDate
    })
  }

  cycleChange(v: any) {
    this.setState({
      cycle: v,
      cycleLabel: v + '个月'
    })
  }

  // 格式化时间
  formatDate(date: any) {
    const pad = (n: number) => n < 10 ? `0${n}` : n;
    const dateStr = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    // const timeStr = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    return `${dateStr}`;
  }

  // 获取几天后的日期
  getNextDay(dateStr: string, days: number){    
    const date = new Date(dateStr);
    const dateTime = date.getTime() + (1000*60*60*24)*days;
    const newDate = new Date(dateTime);
    return newDate
  }

  // 选择支付方式
  payWayComponent() {
    const title = this.state.status === '' ? '请选择' : ''
    return (
      <div className="between-row" style={{height: '40px'}}>
        <span style={{color: '#434343', fontSize: '13px'}}>{this.state.status === '' ? <span style={{color: 'red'}}>*</span> : null}{title}付费方式：</span>
        <span style={{color: '#868686', fontSize: '12px'}}>{this.state.status === '' ? this.detail.primary_room.pay_type : this.state.payWayLabel}</span>
        {/* {this.state.status === '' ?
          <Picker data={this.payWays} cols={2}  onOk={(v: any) => this.payWayChange(v)}>
            <div className="relet-cycle">{this.state.payWayLabel}</div>
          </Picker>  :
          <span style={{color: '#868686', fontSize: '12px'}}>{this.state.payWayLabel}</span>
        } */}
      </div>
    )
  }

  // 扣费部门
  payDepartment() {
    if (this.detail.primary_room.pay_type_id == '2') {
      return (
        <div className="between-row" style={{height: '40px'}}>
          <span style={{color: '#434343', fontSize: '13px'}}>扣费部门：</span>
          <span style={{color: '#868686', fontSize: '13px'}}>{this.detail.primary_room.primary_organization}</span>
        </div>
      )
    } else {
      return null
    }
  }

  payWayChange(v: any) {
    if (v.length > 1) {
      this.payWays[0].children?.forEach(ele => {
        if (ele.value === v[1]) {
          this.setState({
            payWayLabel: ele.label,
            payWay: '2',
            depart: ele.value
          })
        }
      })
    } else {
      this.setState({
        payWayLabel: '工资划扣',
        payWay: '1'
      })
    }
  }

  remarkChange(v: any) {
    this.setState({
      reason: v
    })
  }

  submitButton() {
    if (this.state.status === '5' || this.state.status === '2') {
      return null
    } else {
      let title =  ''
    switch (this.state.status) {
      case '':
        title = '提交续租申请'
        break;
      case '1':
      case '2':
        title = '取消续租申请'
        break
      default:
        title = '添加续租申请'
        break;
    }
    return (
      <Button className="submit-btn"  onClick={() => this.submitClick()}>{title}</Button>
    )
    }
  }

  submitClick() {
    if (this.state.status === '') {
      Modal.alert('续租', '续租后将继续入住本房间，确认续租吗？', [
        { text: '暂不续租', onPress: () => console.log('cancel') },
        { text: '续租', onPress: () => this.submitRelet() },
      ])
    } else if (this.state.status === '1' || this.state.status === '2') {
      this.cancelRelet()
    } else {
      //重新提交续租
      this.setState({
        status: '',
        reletDate: '',
        reason: '',
        payWayLabel: '请选择支付方式',
      })
    }
  }

  render() {
    return (
      <div className="relet">
        {this.state.notice.length > 0 ? this.noticeBarComponent() : null}
        {this.stepComponent()}
        {this.state.status === '4' ? this.rejectReasonComponent() : null}
        {this.detail.is_need_sign ? this.goSignComponent() : null}
        {this.roomInfoComponent()}
        {this.reletComponent()}
        {this.submitButton()}
      </div>
    )
  }
}